import { Action } from '@ngrx/store';
import { ISalesDocument } from '@cemex-core/cmx-api/models/product/models/sales-document.interface';
import { IProduct } from '@cemex-core/cmx-api/models/product/models/product.interface';
import { ContractBalance } from '../models/contract-balance';
import { PaymentTerm, ProductOP } from '@cemex-core/cmx-api';

export const RESET = '[Contract] Reset';

export const LOAD_PRODUCT_CONTRACT = '[Contract] Load contract with product id';
export const LOAD_PRODUCT_CONTRACT_OP = '[Contract] Load contract with product id';
export const LOAD_PRODUCT_CONTRACT_COMPLETE = '[Contract] Load contract with product id complete';
export const LOAD_CONTRACTS_BALANCE = '[Contract] Load contract balance';
export const LOAD_CONTRACT_BALANCE_COMPLETE = '[Contract] Load contract balance complete';
export const LOAD_CONTRACT_PAYMENTS = '[Contract] Load contract payments';
export const LOAD_CONTRACT_PAYMENTS_COMPLETE = '[Contract] Load contract payments complete';

export class ContractLoadAction implements Action {
  readonly type = LOAD_PRODUCT_CONTRACT;

  constructor(public payload: IProduct) {}
}

export class ContractLoadULinkAction implements Action {
  readonly type = LOAD_PRODUCT_CONTRACT_OP;

  constructor(public payload: ProductOP) {}
}

export class ContractLoadCompleteAction implements Action {
  readonly type = LOAD_PRODUCT_CONTRACT_COMPLETE;

  constructor(
    public payload: {
      productId: number;
      salesDocuments: ISalesDocument[];
    },
  ) {}
}

/**
 * Action to retrieve the remaning volume of the contract
 * Right now only applies in Mexico cement
 */
export class ContractsLoadBalanceAction implements Action {
  readonly type = LOAD_CONTRACTS_BALANCE;

  constructor(public payload: ISalesDocument[]) {}
}

export class ContractsLoadBalanceCompleteAction implements Action {
  readonly type = LOAD_CONTRACT_BALANCE_COMPLETE;

  constructor(public payload: { [salesDocumentItemId: number]: ContractBalance }) {}
}

export class ContractsLoadPaymentsAction implements Action {
  readonly type = LOAD_CONTRACT_PAYMENTS;

  constructor(public payload: { contract: ISalesDocument; product: IProduct }) {}
}

export class ContractsLoadPaymentsCompleteAction implements Action {
  readonly type = LOAD_CONTRACT_PAYMENTS_COMPLETE;

  constructor(public payload: { productId: number | string; salesDocumentId: number; paymentTerms: PaymentTerm[] }) {}
}

export class ContractResetAction implements Action {
  readonly type = RESET;

  constructor() {}
}

export type ContractActions =
  | ContractLoadAction
  | ContractLoadCompleteAction
  | ContractResetAction
  | ContractsLoadBalanceAction
  | ContractsLoadBalanceCompleteAction
  | ContractsLoadPaymentsAction
  | ContractsLoadPaymentsCompleteAction;
